<template>
    <div class="px-5 bg-lightest mb-4 pb-4">
        <div class="px-5">

            <div class="dark fs-super pt-4 pb-3">{{niceDate(group.date)}}</div>

            <table class="w-100">
                <tr class="bg-lighter dark bold">
                    <th class="startHourWidth">Departure</th>
                    <th>Resource</th>
                    <th>Duration</th>
                    <th class="notesWidth"></th>
                    <th class="text-center">Available/total</th>
                    <th></th>
                </tr>
                <tr class="fs-large" v-for="event in group.events" :key="event.id">
                    <td class="fs-larger">{{ startHour(event.start) }}</td>
                    <td class="slightlySmallerText">{{ resources(event) }}</td>
                    <td class="slightlySmallerText">{{ hourToDuration(event.duration) }}</td>
                    <td class="slightlySmallerText">{{ event.notes }}</td>
                    <td class="text-center">
                        <div class="fs-largest"><b>{{event.quantityAvailable}}</b>/{{event.maximumLotation}} </div>
                        <div class="fs-smaller">{{event.maximumLotation - event.quantityAvailable}} booked</div>
                    </td>
                    <td class="text-center" v-if="$route.meta.reschedule">
                        <button class="btn widest bg-color-2 border-color-2 fs-large my-2" :disabled="getIsRescheduling" @click="reschedulePrompt(event)">{{selectedEvent && selectedEvent.id == event.id && getIsRescheduling? 'REBOOKING':'REBOOK'}}</button>
                    </td>
                    <td class="text-center" v-if="!$route.meta.reschedule">
                        <button v-if="event.status == -1" class="btn widest border-color-6 bg-color-6 lightest fs-large my-2" @click="showCanceledPopup(event)">EVENT CANCELED</button>
                        <button v-if="!canISellThisEvent(event)" class="btn widest border-color-6 bg-color-6 lightest fs-large my-2" @click="showChannelClosedPopup(event)">Sales channel closed</button>
                        <button v-else class="btn widest border-color-3 fs-large my-2" @click="book(event)">BOOK</button>
                    </td>
                </tr>
            </table>

        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {eventMixin} from '@/mixins/event'

export default {
    mixins:[
        eventMixin
    ],
    data: function(){
        return {
            selectedEvent: null,
        }
    },
    props: {
        product: {
            type: Object,
            default: {}
        },
        group: {
            type: Object,
            default: {}
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getReservation',
            'getSelectedReservation',
            'getIsRescheduling'
        ])
    },
    methods: {
        ...mapActions([
            'setReservationSelectedEvent',
            'rescheduleExistingReservation',
            'addFloatingNotification'
        ]),
        niceDate: function(stringDate) {
            return moment(stringDate).format('DD MMMM YYYY')
        },
        startHour: function(startHourString) {
            // return moment(startHourString).format("hh:mm A")
            return this.formatTime(startHourString)
        },
        resources: function(event) {
            let resourcesNames = [];

            for (let resource of event.eventResources) {
                resourcesNames.push(resource.name);
            }

            let resourcesString = resourcesNames.join(', ');

            return resourcesString;
        },
        book: function(event) {
            this.setReservationSelectedEvent(event);
            this.$router.push('/reservation/resume');
        },
        reschedulePrompt: function(event) {
            //with this we can now if this particular event is being rescheduled so that we can show the "rescheduling" button only on this event
            this.selectedEvent = event

            let vm = this;
            this.$dialog.confirm('Are you sure you want to rebook to ' + moment(event.start).format("DD-MM-YYYY hh:mm A") + '?')
            .then(function () {
                if(vm.getSelectedReservation.hasTransport){
                    vm.$dialog.alert('The current booking has pickup/drop off, this will also rescheduled to '+ moment(event.start).format("DD-MM-YYYY") + ', to change it you should edit the reservation after the rebook.', {okText: 'OK'})
                    .then(function () {
                        vm.registerReschedule(event)
                    })
                    .catch(function () {
                    });
                } else {
                    vm.registerReschedule(event)
                }

            })
            .catch(function () {
            });

        },
        registerReschedule: function(event) {
            this.rescheduleExistingReservation({
                supplierId: this.account.supplierId,
                deliverNotification: false,
                event: event,
                booking: this.getSelectedReservation
            }).then(response => {

                // this.$notify({
                //       group: 'notifications',
                //       position: 'bottom right',
                //       title: null,
                //       text: '<a href="/reservations/view/'+response.data.id+'" target="_blank"><h1>Ticket '+this.formatTicketNumber(response.data.id)+'</h1>'+response.data.customer.name+'<br>'+response.data.event.product.name+'</a>',
                //       duration: 100000,
                // });

                this.addFloatingNotification(
                    {
                        type: -1,
                        title: 'Ticket '+this.formatTicketNumber(response.data.id),
                        message: response.data.customer.name+' <br>'+response.data.event.product.name,
                        bookingId: response.data.id,
                    },
                    'info',
                    {
                        link: '/reservations/view/'+response.data.id
                    }
                )

                // mixpanel
                this.$ma.trackEvent({action:'Rebook Reservation'})

                this.$router.push('/reservations')
            })
        },
        showCanceledPopup: function(event) {
            this.$dialog.alert('The event "'+event.product.name+'" has been canceled.<br>' + (event.statusMessage? 'Cancel message: '+event.statusMessage : ''), {okText: 'OK'})
            .then(function () {

            })
            .catch(function () {
            });
        },
        showChannelClosedPopup: function(event) {
            this.$dialog.alert('The sales channel for this event has been closed.<br>', {okText: 'OK'})
            .then(function () {

            })
            .catch(function () {
            });
        }
    }
}


</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables.scss';

table{
    tr{

        th{
            font-size: $font-size-small;
            font-weight: 600;
            padding: 0.5rem 1rem;
        }

        td{
            padding: 0 1rem;
        }
    }
}

.slightlySmallerText{
    font-size: 0.9rem;
}

.startHourWidth{
    width: 12%;
}
.notesWidth{
    width: 30%;
}
</style>



// WEBPACK FOOTER //
// SingleDay.vue?c1c94b20